import React, {useEffect, useState} from "react"
import {useLocal, useMessage, useSolution, useRoomSetup} from "../AppContext"
import {Button} from "../Components/Button"
import {Clipboard} from "../Components/Clipboard"
import {InputEmail} from "../Components/Input"
import {LoadIndicator} from "../Components/LoadIndicator"
import {ShareIcon} from "../Components/ShareIcon"
import {apiExitIntentLogs} from "../Hooks/Api"
import style from "./ExitIntent.css"
import {iconClose} from "../Helper/Icons"
import {exitIntent as settingsExitIntent} from "../settings";
let timeout = null;

const SESSIONS_STORAGE_KEY__EXIT_INTENT = 'exit-intent'
const LOCALSTORAGE_FLAG__SOLUTION_INTRO_VIDEO_SHOWN = 'solution-intro-video-shown'
const EXIT_INTENT_TIME_RESET =  60 * 60 * 1000 // 60 minutes in ms

export const ExitIntent = () => {
    const local = useLocal()
    const solution = useSolution()
    const message = useMessage()
    const [stateShow, setStateShow] = useState(false)
    const [stateEmail, setStateEmail] = useState("")
    const [stateAgreement, setStateAgreement] = useState(false)
    const roomSetup = useRoomSetup()
    const [hasEditableContentFile, setHasEditableContentFile] = useState(null)

    const language = local.getLangShort()
    const editableContentSource = `${settingsExitIntent.baseUrl}/${language}/`
    const exitIntentDelay = 300

    const actionClose = () => {
        setStateShow(false)
    }

    const actionMail = (event) => {
        setStateEmail(event.target.value)
    }

    const actionMouseEnter = () => {
        clearTimeout(timeout);
    }

    const actionAgreement = () => {
        setStateAgreement(prevCondition => !prevCondition)
    }

    const isSubmitDisabled = () => {
        return stateAgreement === false || stateEmail.trim().length === 0
    }

    const actionSubmit = async () => {
        try {
            await apiExitIntentLogs(stateEmail, solution.getCode())
            message.showSuccess(local.__("Raumcode wurden versendet."))
        } catch (error) {
            message.showError(local.__(error.message))
        }
    }

    const show = async (event) => {
        
        if (event.toElement || event.relatedTarget)
            return

        var lastShowDate = sessionStorage.getItem(SESSIONS_STORAGE_KEY__EXIT_INTENT)
        var showDateDone = false
        
        if (lastShowDate !== null){
           if (((new Date) - Date.parse(lastShowDate)) > EXIT_INTENT_TIME_RESET){
            console.log('Exit Intent time reset. Time past:'+EXIT_INTENT_TIME_RESET);
            sessionStorage.removeItem(SESSIONS_STORAGE_KEY__EXIT_INTENT)
           }else{
            var showDateDone = true
            return
           }
        }
        
        const isSolutionIntroVideoActive = localStorage.getItem(LOCALSTORAGE_FLAG__SOLUTION_INTRO_VIDEO_SHOWN)
        const shouldShowExitIntent =
            stateShow === false && 
            (isSolutionIntroVideoActive == 1 || isSolutionIntroVideoActive === null) && 
            solution.hasPlannings()
        if (shouldShowExitIntent) {
            try {
                timeout = setTimeout(() => {
                    sessionStorage.setItem(SESSIONS_STORAGE_KEY__EXIT_INTENT, new Date().toISOString())
                    setStateShow(true)
                  }, exitIntentDelay);
                await solution.save()
            } catch (error) {

            }
        }
    }

    useEffect(() => {
        document.documentElement.addEventListener("mouseout", show)
        return () => {
            document.documentElement.removeEventListener("mouseout", show);
        }
    }, [])

    useEffect(() => {
        if (hasEditableContentFile) return
    
        fetch(editableContentSource).then(
            response => setHasEditableContentFile(response.status === 200)).catch(
                response => setHasEditableContentFile(response.status === 200)
            )
    }, []);

    useEffect(() => {
        document.documentElement.addEventListener("mouseenter", actionMouseEnter)
    return () => {
        document.documentElement.removeEventListener("mouseenter", actionMouseEnter)
    }
    }, []);

    if (stateShow === false) {
        return null
    }

    const getCurrentVisitDuration = function () {
        const currentTimestamp = Date.now()
        const startingTimestamp = parseInt(sessionStorage.getItem('timestampUserStartedVisit'))
        return currentTimestamp - startingTimestamp
    }

    const defaultContent = <div className={style.defaultContent}>
        <div className={style.title}>{local.__("Jetzt gehen, später weiterplanen!")}</div>
        <div className={style.code}>
            {solution.getCode()}
            {solution.getCode() && <Clipboard code={solution.getCode()}/>}
            {solution.getCode() && <ShareIcon code={solution.getCode()}/>}
            {!solution.getCode() && <div className={style.load}><LoadIndicator/></div>}
        </div>
        <div className={style.cta}>{local.__("Ramcode per E-Mail erhalten und Planung jederzeit fortsetzen.")}</div>
        <InputEmail onChange={actionMail} value={stateEmail} placeholder={local.__("E-Mail Adresse*")} className={style.emailInput}/>
        <div className={style.condition} onClick={actionAgreement}>
            <div>
                <div className={style.radio}>
                    {stateAgreement && <div/>}
                </div>
            </div>
            <div>{local.__("Bitte senden Sie mit meinen Raumcode an die angegebene E-Mail-Adresse und erinnern Sie mich an meine Raumplanung.")}</div>
        </div>
        <Button className={style.submit} isDisabled={isSubmitDisabled()} onClick={actionSubmit}>{local.__("Jetzt Senden")}</Button>
    </div>

    const editableContent = <div className={style.editableContent}>
            <iframe src={editableContentSource}/>
        </div>

    const hasUserStayedAWhile = getCurrentVisitDuration() > settingsExitIntent.millisecondsVisitDuration
    const hasUserSelectedImpressions = roomSetup.getImpressions().length >= settingsExitIntent.numberOfImpressionsSelected

    return <div className={style.container}>
        <div className={style.close} onClick={actionClose}>
            <div>{local.__("zurück zum Raumplaner")}</div>
            <div>{iconClose}</div>
        </div>
        {hasEditableContentFile && hasUserStayedAWhile && hasUserSelectedImpressions ? editableContent : defaultContent }
    </div>
}
